import { useCallback, useMemo } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { selectCheckresponse, clearStatus as clearCheckresonse } from 'slices/checkresponseSlice'
import { selectDriverSend, clearStatus as clearDriverSend } from 'slices/driverSendSlice'
import { selectFinishdelivery, clearStatus as clearFinishdelivery } from 'slices/finishdeliverySlice'
import { selectStartdelivery, clearStatus as clearStartdelivery } from 'slices/startdeliverySlice'

export const ErrorDialog = () => {
  const dispatch = useAppDispatch()

  const checkresponse = useAppSelector(selectCheckresponse)
  const driverSend = useAppSelector(selectDriverSend)
  const finishdelivery = useAppSelector(selectFinishdelivery)
  const startedlivery = useAppSelector(selectStartdelivery)

  const open = useMemo(
    () => [checkresponse.status, driverSend.status, finishdelivery.status, startedlivery.status].includes('failed'),
    [checkresponse.status, driverSend.status, finishdelivery.status, startedlivery.status]
  )
  const errorMessage = useMemo(() => {
    return startedlivery?.error?.altmessage ?? driverSend?.error?.altmessage ?? '通信エラー'
  }, [driverSend.status, startedlivery.status])
  const handleClose = useCallback(() => {
    if (checkresponse.status === 'failed') {
      dispatch(clearCheckresonse())
    } else if (driverSend.status === 'failed') {
      dispatch(clearDriverSend())
    } else if (finishdelivery.status === 'failed') {
      dispatch(clearFinishdelivery())
    } else if (startedlivery.status === 'failed') {
      dispatch(clearStartdelivery())
    }
  }, [checkresponse.status, driverSend.status, finishdelivery.status, startedlivery.status, dispatch])

  return (
    <Dialog open={open} fullWidth>
      <DialogTitle>Error</DialogTitle>
      <DialogContent>
        <DialogContentText>{errorMessage}</DialogContentText>
        <DialogContentText>やり直してください</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" fullWidth onClick={handleClose}>
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  )
}
